var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-empty"},[_c('div',[_c('b-icon',{attrs:{"icon":_vm.icon,"size":"is-medium"}})],1),_vm._v(" "),_c('div',{staticClass:"empty-message"},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }